<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="section">
                    <div class="section-content padding-top-20">
                        <div class="custom-table-scroll-wrapper">
                            <SessionHistoryHeader
                            v-if="dataLoaded"
                            :player-info="playerInfo"
                            :player-sessions="playerSessions"
                            :account="account"
                            />

                            <SessionHistoryTable
                            v-if="dataLoaded"
                            :player-info="playerInfo"
                            :player-sessions="playerSessions"
                            :on-sort-column-change="onSortColumnChange"
                            :order="order"
                            :pagination-criteria="paginationCriteria"
                            :account="account"
                            />

                            <SessionHistoryPagination
                            v-if="dataLoaded"
                            :player-info="playerInfo"
                            :player-sessions="playerSessions"
                            :on-page-change="onPageChange"
                            :pagination-criteria="paginationCriteria"
                            :page-sizes="pageSizes"
                            :on-page-size-change="onPageSizeChange"
                            :total-pages="totalPages"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import SessionHistoryHeader from '@/components/session-history/SessionHistoryHeader'
import SessionHistoryTable from '@/components/session-history/SessionHistoryTable'
import SessionHistoryPagination from '@/components/session-history/SessionHistoryPagination'
import { mapGetters, mapActions } from 'vuex'
import { FETCH_SESSION_HISTORY_DATA } from '@/store/action.types'

export default {
  name: 'SessionHistoryContainer',
  components: {
      SessionHistoryHeader,
      SessionHistoryTable,
      SessionHistoryPagination
  },
  data () {
      return {
          order: false,
          pageSizes: [15, 30, 45],
          dataLoaded: false,

      }
  },
  computed: {
      ...mapGetters([
          'playerInfo',
          'playerSessions',
          'account'
      ]),

      paginationCriteria() {
          return {  
              playerId: this.account.playerId,
              pageNum: 0,
              pageSize: 15,
              sortColumn: 'started',
              sortDirection: 'DESC',
              playerInfo: true
          }
      },
        totalPages: function () {
          return {
              total: Math.ceil(this.playerInfo.totalActivitiesCount / this.paginationCriteria.pageSize)
          }
      },
  },

  watch: {
      account(newValue, oldValue) {
          this.paginationCriteria.playerId = newValue.playerId;
          this.fetchSessionHistoryData(this.paginationCriteria)
      }
  },

  methods: {
      ...mapActions({
          fetchSessionHistoryData: FETCH_SESSION_HISTORY_DATA
      }),
      onPageChange (newPageNumber) {
          this.paginationCriteria.pageNum = newPageNumber;
          this.fetchSessionHistoryData(this.paginationCriteria)
      },

      onPageSizeChange (newPageSize) {
          this.totalPages.total = (Math.ceil(this.playerInfo.totalActivitiesCount / newPageSize));
          this.paginationCriteria.pageSize = newPageSize;
          this.paginationCriteria.pageNum = 0;
        
          this.fetchSessionHistoryData(this.paginationCriteria)
      }, 

      onSortColumnChange (newSortColumn) {
          if(newSortColumn == this.paginationCriteria.sortColumn) {
              this.order = !this.order;
          }else {
              this.order = false;
          }
          this.paginationCriteria.sortColumn = newSortColumn;
      
          this.order ? this.paginationCriteria.sortDirection = 'ASC' : this.paginationCriteria.sortDirection = 'DESC';
          this.fetchSessionHistoryData(this.paginationCriteria)
      },

  },
  mounted () {
    this.fetchSessionHistoryData(this.paginationCriteria)
      .then(() => {
        this.paginationCriteria.playerInfo = false
        this.dataLoaded = true
      })
  }
}
</script>

<style lang="scss" scoped>
    .custom-table-scroll-wrapper {
        overflow: auto;
    }
</style>
